import { Flex, Button } from './shared';
import { theme } from '../design-system';
import styled from '@emotion/styled';

const FineAdjustmentButton = styled(Button)`
  width: 10vw;
  background-color: ${(props) => (props.disabled ? theme.colors.neutralLight : theme.colors.primary)};
  padding: 0.5rem;
  color: black;
  display: flex;
  justify-content: center;

  &:focus {
    background-color: ${(props) => (props.disabled ? theme.colors.neutralLight : theme.colors.primary)};
  }
`;

const Slider = styled.input`
  -webkit-appearance: none;
  width: 100%;
  height: 0.25rem;
  background: ${theme.colors.neutralLight};
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
  }

  &::-moz-range-thumb {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    background-color: ${({ bgColor }) => bgColor};
  }
`;

const ResponsiveContrastSensitivitySlider = ({ contrastValue, handleContrastChange }) => {
  return (
    <Flex width='90vw' maxWidth='700px' centered marginBottom='0.5rem'>
      <FineAdjustmentButton marginRight='1rem' disabled={contrastValue > 99.9} onClick={() => handleContrastChange(contrastValue + 0.1)}>
        {`+ 0.1%`}
      </FineAdjustmentButton>

      <Slider
        bgColor={theme.colors.primary}
        type='range'
        min={0}
        max={100}
        value={100 - contrastValue}
        onChange={(e) => handleContrastChange(100 - e.target.value)}
      />

      <FineAdjustmentButton marginLeft='1rem' disabled={contrastValue < 0.1} onClick={() => handleContrastChange(contrastValue - 0.1)}>
        {`- 0.1%`}
      </FineAdjustmentButton>
    </Flex>
  );
};

export default ResponsiveContrastSensitivitySlider;
